import Tag from '@/components/Tag.jsx';
import { FiChevronDown, FiChevronRight } from '@/components/react-icons/main';
import { DeleteIcon, EditIcon } from '@/lib/constants/icons.js';
import { useState } from 'react';
import Button from './Button.jsx';
import IconV2 from './v2/IconV2.jsx';

const DocsCard = ({ title, icon, content, onEdit, onDelete, isEditing, className = '', isUserCard = false, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit();
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete();
  };

  return (
    <div className={`docs-card ${className}`}>
      <div className={`docs-card-header ${isCollapsed ? 'collapsed' : ''}`} onClick={toggleCollapse}>
        <div className="docs-card-title-wrapper">
          {icon && (
            <div className="docs-card-icon">
              <IconV2 icon={icon} />
            </div>
          )}
          <div className="docs-card-title">{title}</div>
          {isEditing && (
            <Tag className="warn" size="sm">
              Editing...
            </Tag>
          )}
        </div>
        <div className="docs-card-actions">
          {!isEditing && (
            <>
              {onEdit && <Button size="sm" className="ghost" icon={EditIcon} onClick={handleEdit} />}
              {onDelete && <Button size="sm" className="ghost" icon={DeleteIcon} onClick={handleDelete} />}
              <Button size="sm" className="ghost" icon={isCollapsed ? FiChevronRight : FiChevronDown} onClick={toggleCollapse} />
            </>
          )}
        </div>
      </div>
      {!isCollapsed && (
        <>
          {content && <div className={`markdown-content ${isUserCard ? 'user-card' : ''}`} dangerouslySetInnerHTML={{ __html: content }} />}
          {!content && children}
        </>
      )}
    </div>
  );
};

export default DocsCard;
